if (!customElements.get('glidify-community-videos')) {
  customElements.define('glidify-community-videos', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const {signal} = this.controller;
      const dialog = this.querySelector('dialog');
      const player = this.querySelector('.gcv-player');
      if (!dialog || !player) return;
      this.addEventListener('click', event => {
        const opener = event.target.closest('[data-gcv-open]');
        if (opener && this.contains(opener)) {
          const template = [...this.querySelectorAll('template[data-gcv-media]')].find(t => t.dataset.gcvMedia === opener.dataset.gcvOpen);
          if (!template) return;
          this.previousFocus = opener;
          player.replaceChildren(template.content.cloneNode(true));
          this.querySelector('.gcv-dialog-title').textContent = template.dataset.gcvTitle;
          dialog.showModal();
          player.querySelector('video')?.play().catch(() => {});
        }
        if (event.target.closest('[data-gcv-close]')) dialog.close();
      }, {signal});
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      }, {signal});
      dialog.addEventListener('close', () => {
        player.querySelector('video')?.pause();
        player.replaceChildren();
        if (this.previousFocus?.isConnected) this.previousFocus.focus({preventScroll: true});
      }, {signal});
    }
    disconnectedCallback() {
      this.querySelector('video')?.pause();
      this.controller?.abort();
    }
  });
}
